import React from 'react';
import { useTranslation } from 'react-i18next';
import PasswordInput from 'apollo-react/components/PasswordInput';
import Info from 'apollo-react-icons/Info';
import Tooltip from 'apollo-react/components/Tooltip';

const PasswordField = ({
  field = {},
  meta = {},
  label,
  onChange,
  value,
  required,
  placeholder,
  fullWidth = true,
  disabled,
  tooltipText,
}) => {
  const { t } = useTranslation();
  return (
    <PasswordInput
      {...field}
      label={
        <span
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 4,
            lineHeight: '21px',
          }}
        >
          {label}{' '}
          <Tooltip
            title={tooltipText || t('common.passwordTooltip')}
            placement="top"
          >
            <Info
              fontSize="extraSmall"
              style={{ color: '#595959', cursor: 'pointer' }}
            />
          </Tooltip>
        </span>
      }
      placeholder={placeholder}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error ? meta.error : ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth={fullWidth}
      required={required}
      value={value}
      disabled={disabled}
    />
  );
};

export default PasswordField;
